<template>
        <div class="app-container">
            <!--搜索栏-->
            <div class="search-box">
            <el-form ref="searchParamsForm" :inline="true" :model="searchParams" size="small">
              <el-form-item :label="$t('kbinfo.keyword', { msg: 'kbinfo.keyword' })" prop="title">
                <el-input v-model="searchParams.title" style="width: 260px;" :placeholder="$t('kbinfo.keywordD', { msg: 'kbinfo.keywordD' })" />
              </el-form-item>
              <el-form-item :label="$t('kbinfo.kbType', { msg: 'kbinfo.kbType' })" prop="typeId">
                <!-- <el-select v-model="searchParams.typeId" style="width: 260px" :placeholder="$t('kbinfo.kbTypeD', { msg: 'kbinfo.kbTypeD' })" filterable>
                  <el-option :value="0" :label="$t('kbinfo.no', { msg: 'kbinfo.no' })" />
                  <el-option
                    v-for="types in typeList"
                    :key="types.id"
                    :value="types.id"
                    :label="types.type"
                  />
                </el-select> -->
                <el-cascader 
                :placeholder="$t('kbinfo.kbTypeD', { msg: 'kbinfo.kbTypeD' })"
                ref="refCascader"
                @change="handleCascader"
                :options="typeTree" 
                v-model="searchParams.typeId" 
                :props="{
                  value: 'id',
                  label: 'type'
                }"
                ></el-cascader>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getAllList(this.searchParams.typeId,this.searchParams.title);">{{ $t('kbinfo.select', { msg: 'kbinfo.select' }) }}</el-button>
                <el-button @click="resetSearchParams('searchParamsForm')">{{$t('kbinfo.reset', { msg: 'kbinfo.reset' }) }}</el-button>
              </el-form-item>
            </el-form>
          </div>
            <el-table
            tooltip-effect="dark"
            @row-dblclick="handleOpenDrawer"
            :data="tableData"
            border
            stripe
            highlight-current-row
            style="width: 100%;text-align: center;"
            :row-class-name="tableRowClassName"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}">
            <el-table-column
                v-if="false"
                prop="id"
                :label="$t('kbinfo.table.id', { msg: 'kbinfo.table.id' }) "
                width="60px"
                >
            </el-table-column>
            <el-table-column
                prop="title"
                :label="$t('kbinfo.table.title', { msg: 'kbinfo.table.title' }) "
                >
            </el-table-column>
            <el-table-column  :label="$t('kbType.tag', { msg: 'kbType.tag' })" width="280">
            <template #default="scope">
            <el-tag
            v-for="tag in scope.row.tags"
            :key="tag.id"
            effect="dark"
            size="mini"
            type="success">
              {{tag.tag}}
          </el-tag>
          </template>
          </el-table-column>
            <!-- <el-table-column
                prop="type"
                :label="$t('kbinfo.table.kbType', { msg: 'kbinfo.table.kbType' }) "
                width="140px"
                >
            </el-table-column> -->
            <!-- <el-table-column
                prop="parentType"
                label="父类别 "
                width="130px"
                >
            </el-table-column> -->
            <el-table-column
            :label="$t('kbinfo.table.kbType', { msg: 'kbinfo.table.kbType' }) "
                width="200">
                <template #default="scope">
                  {{ scope.row.parentType+' / '+scope.row.type }}
                </template> 
            </el-table-column>
            <el-table-column
                prop="updateTime"
                :label="$t('kbinfo.table.time', { msg: 'kbinfo.table.time' }) "
                width="180px">
            </el-table-column>
            </el-table>
                <div class="pagination-tools">
            <!--
                background:带背景的页码
                layout：分页条布局
                    prev：上页按钮
                    pager：页码
                    next：下一页按钮
                    sizes:每页显示数量
                    jump：跳转到第几页
                    ->：定位其内容居右显示
                    total：总条目数
                :page-size.sync="pageParam.pageSize":每页条目数   问题1
                :current-page.sync="pageParam.pageNum"：当前页码  问题2
                :page-sizes="pageSizes"：条目列表
                :total="total"：总条目数
                :hide-on-single-page="true":当只有一页时隐藏分页条
            -->
            <el-pagination
                background
                layout="sizes,prev, pager, next,jumper,->,total"
                :page-size="this.pageParam.pageSize"
                :current-page="this.pageParam.pageNum"
                :page-sizes="pageSizes"
                :total="total"
                :hide-on-single-page="false"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                :disabled="paginationDisabled"
            >
            </el-pagination>
            </div>
        </div>

        <el-drawer
          v-model="showDrawer"
          destroy-on-close
          size="60%"
          :title="$t('kbinfo.kbDetail', { msg: 'kbinfo.kbDetail' })"
        >
          <div style="padding: 20px;font-size: 20px;">
            <el-descriptions :title="knowledgeBase.title" direction="vertical" :column="1">
              <el-descriptions-item>
                <template #label><el-text style="font-size: 16px;">{{ $t('kbinfo.solutionm', { msg: 'kbinfo.solutionm' }) }}</el-text></template>
                <div style="border: 1px solid #ccc;">
                  <Editor
                      style="height: 800px; overflow-y: hidden;"
                      v-model="knowledgeBase.solution"
                      :defaultConfig="editorConfig"
                      :mode="mode"
                      @onCreated="onCreated"
                  />
                  </div>
              </el-descriptions-item>
              <el-descriptions-item :label="$t('kbinfo.creator', { msg: 'kbinfo.creator' })">
                <template #label><el-text style="font-size: 16px;">{{ $t('kbinfo.creator', { msg: 'kbinfo.creator' }) }} {{ knowledgeBase.creator }}</el-text></template>
              </el-descriptions-item>
              <el-descriptions-item :label="$t('kbinfo.updateTime', { msg: 'kbinfo.updateTime' })">
                <template #label><el-text style="font-size: 16px;">{{ $t('kbinfo.updateTime', { msg: 'kbinfo.updateTime' }) }}  {{ knowledgeBase.updateTime }}</el-text></template>
              </el-descriptions-item>
            </el-descriptions>
              <el-button 
                v-if="isAdmin"
                size="large"
                type="danger"
                icon="el-icon-edit"
                style="float: left;"
                @click="handleReview(0,this.knowledgeBase.id)">{{ $t('kbReview.backToApprove', { msg: 'kbReview.backToApprove' }) }}
              </el-button>
          </div>
        </el-drawer>
  </template>
  <script>
  import { baseUrl_New } from '../../axios/urlconfig';
  import { Editor } from '@wangeditor/editor-for-vue';
  import { i18nChangeLanguage } from '@wangeditor/editor';
  import { getRequest,postRequest,deleteRequest } from '../../axios/axios';



  export default {
    components: { Editor },
      data() {
        return {
          editor: null,
          html: '',
          toolbarConfig: { },
          editorConfig: { placeholder: this.$t('issue.issueD', { msg: 'issue.issueD' }) },
          mode: 'default', // or 'simple'
          isAdmin: sessionStorage.role.includes('超级管理员'),
          showDrawer: false,
          knowledgeBase: null, //单一知识库
          activeName: 'second',
          kbList: [
            {
            "type": "数据库",
            "title": "关于分表分库",
            "solution": "垂直拆分表与水平拆分表，尽量把表变小",
            "updateTime": "2023-08-01 17:01:51"
            },
            {
            "type": "数据库1",
            "title": "关于分表分库",
            "solution": "垂直拆分表与水平拆分表，尽量把表变小",
            "updateTime": "2023-08-04 17:01:51"
            },{
            "type": "数据库2",
            "title": "关于分表分库",
            "solution": "垂直拆分表与水平拆分表，尽量把表变小",
            "updateTime": "2023-08-03 17:01:51"
            },{
            "type": "数据库3",
            "title": "关于分表分库",
            "solution": "垂直拆分表与水平拆分表，尽量把表变小",
            "updateTime": "2023-08-02 17:01:51"
            }
        ],
        tableData: [],
        paginationDisabled: false,
        pageParam: {//分页参数
          pageNum: 1,//当前页
          pageSize: 10,//每页条目数据
        },
        total: 0,//总条目数
        pageSizes: [10, 20, 30, 40],//每页显示条目数列表
        searchParams: {
        pageNum: 1,//当前页
        pageSize: 10,//每页条目数据
        title: null,
        typeId: null,
        statsearchParamsus: null
        },
        title:'',
        typeList:[],
        typeTree:[],//知识类别两层结构
        form: {   //新增知识库
          title: '',
          typeId:'',
          resource: '',
          isPass:0,
          solution: '',
        },
        rules:{
          title: [
            { required: true, message: this.$t('kbinfo.themeD', { msg: 'kbinfo.themeD' }), trigger: 'blur' }
          ],
          typeId: [
            { required: true, message: '' , trigger: 'blur'}
          ],
          solution: [
            { required: true, message: this.$t('kbinfo.solutionD', { msg: 'kbinfo.solutionD' }), trigger: 'blur' }
          ],
        },
        };
      },

      created(){
        this.getAllList();
        this.getTypeAll();
        this.getTypeTree();
      },

      beforeUnmount() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
      },

      methods: {
        onCreated(editor) {
          this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
          this.editor.disable();
          i18nChangeLanguage(this.localStorage.getItem('language'));
        },
        handleClick(tab, event) {
          //console.log(tab, event);
        },
        //table样式
        // tableRowClassName({row, rowIndex}) {
        //   if (rowIndex%4 === 1) {
        //     return 'warning-row';
        //   } else if (rowIndex%4 === 3) {
        //     return 'success-row';
        //   }
        //   return '';
        // },

        //表格数据列表
         //获取所有的知识类别
       getAllList(typeId,title){
        const param = {
          typeId: typeId,
          title: title
        }
        getRequest(baseUrl_New+'/kb/page/'+ this.pageParam.pageNum + '/' + this.pageParam.pageSize,param).then(response=>{
          //获得服务器端回传的map对象
          let resultMap = response;
            //从集合中获取用户列表及总条目数
            this.tableData = resultMap.list;
            this.total = resultMap.total;
        })
       },
        handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pageParam.pageSize = val;
        this.getAllList(this.searchParams.typeId,this.searchParams.title)
        },
        handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.pageParam.pageNum = val;
        this.getAllList(this.searchParams.typeId,this.searchParams.title)
        },
        //知识类别种类
        getTypeAll(){
         /** getTypeAll().then(response=>{
            let result=response.data;  //这些都是多余的  需要删除
            this.typeList=result.list;
          }) */
          getRequest(baseUrl_New+'/kType/list').then(response=>{
            console.log(response);
            let resultMap = response;
            this.typeList=resultMap.list;
          })
        },
        handleReview(index,id){
          this.$confirm(this.$t('kbReview.toBeApproved', { msg: 'kbReview.toBeApproved' }),  this.$t('issue.tips', { msg: 'issue.tips' }),{
            confirmButtonText:  this.$t('exportIssue.confirm', { msg: 'exportIssue.confirm' }),
            cancelButtonText:  this.$t('exportIssue.cancel', { msg: 'exportIssue.cancel' }),
            cancelButtonClass: 'btn-custom-cancel',
            type: 'warning'
        }).then(() => {
            postRequest(baseUrl_New + `/kb/revertById/${id}`)
            .then(response=>{
              console.log(response);
                if (response.code == 0){
                this.$message.success(this.$t('kbReview.approveS', { msg: 'kbReview.approveS' }))
                    this.getTypeAll();
                    this.getAllList(this.searchParams.typeId,this.searchParams.title)
                    this.showDrawer = false;
                }else{
                this.message.error(this.$t('kbReview.approveF', { msg: 'kbReview.approveF' }));
                }
            })
        })
        },
        resetSearchParams(formName) {  //清空查询列表
        this.$refs[formName].resetFields();
        this.getAllList(this.searchParams.typeId,this.searchParams.title)
        this.paginationDisabled = false;
      },
      onSubmit(formName) { //新增知识库
        //console.log('submit!');
        this.html = this.form.solution;
        this.$refs[formName].validate((valid) => {
          if (valid) {
        var that = this
        postRequest(baseUrl_New + '/kb/addKB',{
          title:this.form.title,
          typeId:this.form.typeId,
          solution:this.form.solution,
          isPass:this.form.isPass,
        }).then(resp=>{
          this.$message.success(this.$t('kbinfo.newKbD', { msg: 'kbinfo.newKbD' }));
          this.resetForm('form')
        }).catch(err => {
          this.$message.error(this.$t('issue.error', { msg: 'issue.error' }))
        })
          //  alert('submit!');
          } else {
           // console.log('error submit!!');
            return false;
          }
        });
       
      },
      resetForm(form) {
        this.$refs[form].resetFields();
       // this.form=[];
        // this.form.title=null;
        // this.form.typeId=null;
        // this.form.type=null;
        // this.form.solution=null;
      },
      //不再使用
      // getAllByTitleKey(){
      //   const params =  { 'title': this.searchParams.title, 'typeId': this.searchParams.typeId };
      //   getRequest(baseUrl_New+'/kb/titleKey', params
      //     // title:{title:this.searchParams.title}
      //   ).then(response=>{
      //     console.log(response);
      //     this.tableData = response.data.list;
      //     this.total = response.data.count;
      //     this.paginationDisabled = true;
      //        //获得服务器端回传的map对象
      //     // let resultMap = response.data;
      //     //   //从集合中获取用户列表及总条目数
      //     // this.tableData = resultMap.list;
      //     //this.total = resultMap.total;
      //     })
      // },
      // getAllBytype(){
      //   axios.get(baseUrl_New+'/kb/byTypeId/'+this.searchParams.typeId,
      //   ).then(response=>{
      //     // console.log(response);
      //     this.tableData = response.data.data.list;
           
      //     })
      // },
      handleOpenDrawer(val){
        this.showDrawer = true;
        this.knowledgeBase = val;
      },
      getTypeTree(){
        getRequest(baseUrl_New+'/kType/getType').then(response=>{
          console.log(response);
            let resultMap = response.data;
            this.typeTree=resultMap.typeTree;
          })
      },
      handleCascader(){
        this.searchParams.typeId = this.$refs["refCascader"].getCheckedNodes()[0].value; //获取最后一个id
      },


      }
    };
  </script>

<style src="@wangeditor/editor/dist/css/style.css"></style>

<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-form-item__label-wrap {
  margin-left: 5px !important;
}

.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}
</style>